import { render, staticRenderFns } from "./ShareLandingCom.vue?vue&type=template&id=c3bd7666&scoped=true"
import script from "./ShareLandingCom.vue?vue&type=script&lang=js"
export * from "./ShareLandingCom.vue?vue&type=script&lang=js"
import style0 from "./ShareLandingCom.vue?vue&type=style&index=0&id=c3bd7666&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bd7666",
  null
  
)

export default component.exports